import React from 'react';
import { Link } from 'react-router-dom';
import './APropos.css';
import imageAPropos from '../../assets/images/divers/autre/i2.jpg'; 

function APropos() {
  return (
    // On utilise une classe plus descriptive pour la page
    <div className="apropos-page">
      <div className="apropos-container">
        <div className="apropos-text-content">
          <h1>Notre Histoire Scintillante</h1>
          
          <p>
            Née de la passion pour les océans mystérieux et les créatures légendaires qui les habitent, <strong>Couleur Sirène</strong> a été créée pour apporter une touche de magie marine dans votre quotidien. Nous croyons que chacun possède une lumière intérieure unique, aussi chatoyante que les écailles d'une sirène.
          </p>
          
          <p>
            Nos produits sont pensés et conçus avec amour, en s'inspirant des trésors cachés des abysses : les reflets nacrés des coquillages, les couleurs profondes des coraux et l'éclat des perles rares.
          </p>
          
          <h2>Notre Mission</h2>
          <p>
            Révéler la sirène qui sommeille en vous grâce à des créations uniques et de qualité, tout en nous engageant à protéger la beauté de nos océans pour les générations futures.
          </p>

          <Link to="/catalogue" className="cta-button">Découvrir nos créations</Link>
        </div>

        <div className="apropos-image-content">
          <img src={imageAPropos} alt="L'esprit de Couleur Sirène" />
        </div>
      </div>
    </div>
  );
}

export default APropos;